<div class="container-sm px-alt-3 pb-5 main-container">
    <app-tag-base [tagType]="'RESERVATION'"></app-tag-base>
</div>